module.exports = __webpack_public_path__ + "img/titleC.fd2890ca.png";